import { NgModule } from '@angular/core';
import { AppointmentTypePipe } from './appointment-type.pipe';
import { FLXCallFilterPipe } from './call-filter.pipe';
import { FLXClaimFilterPipe } from './claim-filter.pipe';
import { ExcessCollectionPipe } from './excess-collection.pipe';
import { FLXFromBooleanPipe } from './fromBoolean.pipe';
import { FLXFromCamelPipe } from './fromCamel.pipe';
import { FLXFromDatePipe } from './fromDate.pipe';
import { FLXFromPascalPipe } from './fromPascal.pipe';
import { FLXFromSnakePipe } from './fromSnake.pipe';
import { JobStatusPipe } from './job-status.pipe';
import { FLXObjectKeysPipe } from './keys.pipe';
import { ObjectKeysPipe } from './object-keys.pipe';
import { PaymentMethodPipe } from './payment-method.pipe';
import { FLXProperEnglishPipe } from './properEnglish.pipe';
import { QuickFilterPipe } from './quickfilter.pipe';
import { SearchFilterPipe } from './search.pipe';
import { SpInterestPipe } from './sp-interest.pipe';
import { IdToNamePipe } from './id-to-name.pipe';
import { SpSkillNamePipe } from './sp-skill-name.pipe';
import { StateNamePipe } from './state-name.pipe';
import { TelephoneNumberPipe } from './telephone-number.pipe';
import { FLXToHuman } from './toHuman.pipe';
import { FLXObjectValuesPipe } from './values.pipe';
import { FLXRealEnglishPipe } from './realEnglish.pipe';
import { AbsoluteNumberPipe } from './absolute-number.pipe';
import { FLXIsArrayPipe } from './is-array.pipe';
import { IsEmptyPipe } from './is-empty.pipe';
import { MoveAssessorJobsToTopPipe } from './move-assessor-jobs-to-top.pipe';
import { DateWithoutTimePipe } from './date-without-time.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { ArrayContainsPipe } from './arrayContains.pipe';

export const pipes = [
  AppointmentTypePipe,
  AbsoluteNumberPipe,
  ArrayContainsPipe,
  FLXCallFilterPipe,
  FLXClaimFilterPipe,
  ExcessCollectionPipe,
  FLXFromBooleanPipe,
  FLXFromCamelPipe,
  FLXFromDatePipe,
  FLXFromPascalPipe,
  FLXFromSnakePipe,
  JobStatusPipe,
  FLXObjectKeysPipe,
  ObjectKeysPipe,
  PaymentMethodPipe,
  FLXProperEnglishPipe,
  QuickFilterPipe,
  SearchFilterPipe,
  SpInterestPipe,
  IdToNamePipe,
  SpSkillNamePipe,
  StateNamePipe,
  TelephoneNumberPipe,
  FLXToHuman,
  FLXObjectValuesPipe,
  FLXRealEnglishPipe,
  FLXIsArrayPipe,
  IsEmptyPipe,
  MoveAssessorJobsToTopPipe,
  DateWithoutTimePipe,
  SafeHtmlPipe,
];
@NgModule({
  declarations: [
    AppointmentTypePipe,
    AbsoluteNumberPipe,
    ArrayContainsPipe,
    FLXCallFilterPipe,
    FLXClaimFilterPipe,
    ExcessCollectionPipe,
    FLXFromBooleanPipe,
    FLXFromCamelPipe,
    FLXFromDatePipe,
    FLXFromPascalPipe,
    FLXFromSnakePipe,
    JobStatusPipe,
    FLXObjectKeysPipe,
    ObjectKeysPipe,
    PaymentMethodPipe,
    FLXProperEnglishPipe,
    QuickFilterPipe,
    SearchFilterPipe,
    SpInterestPipe,
    IdToNamePipe,
    SpSkillNamePipe,
    StateNamePipe,
    TelephoneNumberPipe,
    FLXToHuman,
    FLXObjectValuesPipe,
    FLXRealEnglishPipe,
    FLXIsArrayPipe,
    IsEmptyPipe,
    MoveAssessorJobsToTopPipe,
    DateWithoutTimePipe,
    SafeHtmlPipe,
  ],
  exports: [
    AppointmentTypePipe,
    AbsoluteNumberPipe,
    ArrayContainsPipe,
    FLXCallFilterPipe,
    FLXClaimFilterPipe,
    ExcessCollectionPipe,
    FLXFromBooleanPipe,
    FLXFromCamelPipe,
    FLXFromDatePipe,
    FLXFromPascalPipe,
    FLXFromSnakePipe,
    JobStatusPipe,
    FLXObjectKeysPipe,
    ObjectKeysPipe,
    PaymentMethodPipe,
    FLXProperEnglishPipe,
    QuickFilterPipe,
    SearchFilterPipe,
    SpInterestPipe,
    IdToNamePipe,
    SpSkillNamePipe,
    StateNamePipe,
    TelephoneNumberPipe,
    FLXToHuman,
    FLXObjectValuesPipe,
    FLXRealEnglishPipe,
    FLXIsArrayPipe,
    IsEmptyPipe,
    MoveAssessorJobsToTopPipe,
    DateWithoutTimePipe,
    SafeHtmlPipe,
  ],
})
export class PipesModule {}
